import { Link } from "react-router-dom";
import { IRoom, WithId } from "../@types/room";
import { ServiceContextType } from "../@types/service";
import { useFirebase } from "../FbContex";
import { activeNodes } from "../lib/selectors";
import { summaryOf } from "./widgets/summary";

export default function DeviceCard({ room }: { room: WithId<IRoom> }) {
  const ctx = useFirebase() as ServiceContextType;
  const nodes = activeNodes(ctx.devices, room.id).slice(0, 3);

  return (
    <Link to={`/room/${room.slug || room.id}`}>
      <div className="bg-stone-800/80 w-40 h-36 rounded-lg mb-4">
        <div className="text-center my-2 text-gray-100">{room.name}</div>
        {nodes.map((d) => (
          <div
            key={d.id}
            className="flex flex-row justify-between items-center py-1 px-2"
          >
            <i className={`fas fa-${d.icon} text-stone-400`} />
            <div className="text-cyan-300">{summaryOf(d, ctx)}</div>
          </div>
        ))}
      </div>
    </Link>
  );
}
